import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    field: "privacy_policy",
    fallback:
      "ECOREXS collects only the information required to deliver its services and process payments, including your name, email and billing details. Payment card data is handled securely by Stripe and never stored by ECOREXS. We do not sell your personal data. For questions about your data, contact support@ecorexs.com or use your client portal.",
  },
  terms: {
    title: "Terms of Service",
    field: "legal_terms",
    fallback:
      "By using ECOREXS services you agree to the service descriptions, pricing and billing frequency shown at the time of purchase. Services are provided on a best-effort basis. Each service and its terms are presented clearly before you authorize any payment.",
  },
  billing: {
    title: "Billing & Cancellation Policy",
    field: "cancellation_policy",
    fallback:
      "Subscriptions renew automatically at the frequency shown when you authorized the payment (weekly, every two weeks, monthly, or yearly). Yearly plans, when offered, are billed in full in advance once per year. You may cancel a subscription at any time from your client portal or by contacting support@ecorexs.com; cancellation takes effect at the end of the current billing period, and access continues until then. One-time payments are non-recurring. We never apply charges you have not authorized.",
  },
};

export default function LegalPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const meta = CONTENT[slug] || CONTENT.privacy;
  const [legal, setLegal] = useState(null);

  useEffect(() => {
    api.get("/public/legal").then((r) => setLegal(r.data)).catch(() => setLegal({}));
  }, []);

  const body = (legal && legal[meta.field]) || meta.fallback;
  const merchant = (legal && legal.merchant_info) || "ECOREXS — Managed Digital Infrastructure\nOperated by ECOREXS.\necorexs.com";

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-[#E2EBF0]">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <button onClick={() => navigate("/")}><Logo /></button>
          <button onClick={() => navigate("/")} className="text-sm text-[#4A635A] flex items-center gap-1" data-testid="legal-back">
            <ArrowLeft className="h-4 w-4" /> Home
          </button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-14">
        <h1 className="font-heading font-bold text-3xl text-[#0D3B2D]" data-testid="legal-title">{meta.title}</h1>
        <p className="mt-6 text-[#0D3B2D]/80 leading-relaxed whitespace-pre-wrap">
          {body.split(/\*\*(.+?)\*\*/g).map((part, i) => (i % 2 ? <strong key={i} className="text-[#0D3B2D]">{part}</strong> : part))}
        </p>
        <div className="mt-10 pt-6 border-t border-[#E2EBF0]">
          <div className="font-mono text-xs uppercase tracking-widest text-[#4A635A] mb-2">Merchant Information</div>
          <p className="text-sm text-[#0D3B2D]/80 whitespace-pre-wrap">{merchant}</p>
          <p className="text-sm text-[#0D3B2D]/80 mt-2" data-testid="legal-support-email">
            Support: <a href="mailto:support@ecorexs.com" className="text-[#10B981] hover:underline">support@ecorexs.com</a>
          </p>
        </div>
      </main>
    </div>
  );
}
